import React from "react";

import { Button } from "antd";
import Modal from "antd/es/modal/Modal";

import "./ConfirmModal.css";

export default class ConfirmExitModal extends React.Component {
  render() {
    const {
      headerText,
      bodyText,
      buttonText,
      buttonFunctions,
      saveLoading,
    } = this.props;

    return (
      <Modal
        open
        maskClosable={false}
        closable={false}
        centered
        footer={null}
        width="448px"
        wrapClassName="ConfirmModal"
        className="ConfirmModal"
      >
        <div className="envSpecManagerConfirmDel">
          <div className="envSpecManagerConfirmDelTitle">{headerText}</div>
          <div className="envSpecManagerConfirmDelTitleMessage">{bodyText}</div>
          <div className="envSpecManagerConfirmDelBtn">
            <Button htmlType="button" type="default" onClick={buttonFunctions[0]}>{buttonText[0]}</Button>
            <Button
              htmlType="button"
              type="primary"
              onClick={buttonFunctions[1]}
              disabled={saveLoading}
              loading={saveLoading}
            >
              {buttonText[1]}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}
